export const RICH_TOOLTIP_VARIANTS = Object.freeze({
  STANDARD: 'standard',
  COMPACT: 'compact',
});

export const RICH_TOOLTIP_INTERACTION_MODES = Object.freeze({
  PINNABLE: 'pinnable',
  HOVER_ONLY: 'hover-only',
});

export const RICH_TOOLTIP_TONES = Object.freeze(['sage', 'blue', 'amber', 'brick', 'slate']);

export const RICH_TOOLTIP_DRIVER_KINDS = Object.freeze(['positive', 'negative', 'contextual']);

export const RICH_TOOLTIP_FRESHNESS = Object.freeze([
  'current',
  'mixed',
  'stale-warning',
  'stale',
  'unknown',
]);

export const RICH_TOOLTIP_MAX_DRIVERS = 5;
export const RICH_TOOLTIP_WARNING_CONFIDENCE_THRESHOLD = 0.8;

export function isRichTooltipVariant(value) {
  return Object.values(RICH_TOOLTIP_VARIANTS).includes(value);
}

export function isRichTooltipInteractionMode(value) {
  return Object.values(RICH_TOOLTIP_INTERACTION_MODES).includes(value);
}

export function isRichTooltipTone(value) {
  return RICH_TOOLTIP_TONES.includes(value);
}

export function clampTooltipDrivers(drivers = [], max = RICH_TOOLTIP_MAX_DRIVERS) {
  return Array.isArray(drivers) ? drivers.slice(0, max) : [];
}
